import styled from 'styled-components'

export default styled.span`
  background: url(${UNVERSIONED_STATICS_PATH}images/mobiletabs/${props => props.theme.name}/tvprogram.svg) no-repeat;
  display: block;
  height: 34px;
  margin: 3px auto;
  width: 42px;
`
